import React from 'react';
import '../App.css';
import { Headerapp } from './/headerapp'
import { Bodyappsignupbody} from './/bodyappsignupbody'
import { Footerapp } from './/footerapp'

export class Bodyappsignup extends React.Component {
  constructor(props) {
      super(props);
  }
  state = {
      mail:''
  }

  render(){
    return (
      <div className="App">        
        <Headerapp/>
        <Bodyappsignupbody setStateMailP={this.props.setStateMailP}/>
        <Footerapp/>
      </div>
    );
  }



}